// http://localhost:5002/mobile-metrics/commission-estimates/single-product-type'
/*--data '{
"product_type_id": 1316,
  "category_id": 63
}'*/

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { AuthenticationService, DefaultsService } from 'src/app/core/providers';
import { MetricsService } from 'src/app/core/providers/services/metrics.service';
import { environment } from 'src/environments/environment';
import { FiltersService } from 'src/app/filters/filters.service';

export const COMMISSION_ESTIMATES_CACHE: Map<string, any[]> = new Map();

export const getCacheKey = (body: any) => {
  const key = JSON.stringify(body);
  return key;
};

type CommissionEstimate = {
  todo: string;
};

@Injectable()
export class CommissionEstimateService extends MetricsService {
  constructor(
    public http: HttpClient,
    public translateService: TranslateService,
    public filtersService: FiltersService,
    protected defaultsService: DefaultsService,
    protected authenticationService: AuthenticationService
  ) {
    super(
      translateService,
      filtersService,
      defaultsService,
      authenticationService
    );
  }

  getEstimateConfiguration(
    categoryId: number,
    productTypeId: number
  ): Promise<any> {
    const url = `${environment.metricsApiUrl}/mobile-metrics/commission-estimates/single-product-type`;
    const body = {
      product_type_id: productTypeId,
      category_id: categoryId,
    };

    return new Promise((resolve, reject) => {
      const cacheKey = getCacheKey(body);

      if (COMMISSION_ESTIMATES_CACHE.has(cacheKey)) {
        const cachedValue = COMMISSION_ESTIMATES_CACHE.get(cacheKey);
        return resolve(cachedValue);
      }

      const promise: Promise<Array<CommissionEstimate> | undefined> = this.http
        .post<Array<CommissionEstimate>>(url, body)
        .toPromise();

      promise
        .then((result) => {
          return resolve(result);
        })
        .catch((error) => {
          console.error(
            'Error fetching commission estimate configuration:',
            error
          );
          return reject(error);
        });
    });
  }
}
